<template>
  <div v-if="isHeader">
    <span class="text-overflow text-clamp-2"
    v-tooltip="rowField.customField.label.toString().length > 24 ? rowField.customField.label : ''">{{ rowField.customField.label }}</span>
  </div>
  <div v-else-if="!isHeader">
    <qty-input
      v-if="isEditable"
      type="number" min="0" :max="QTY_Max"
      v-model.number="cfValue" :roundTo="4"
      :value="cfValue"
      @update:value="(val) => { cfValue = val; updateCfValue(); }"
      @blur="validateFields()" :class="orderCf.hasError ? 'archived-border' : ''"
    ></qty-input>
    <span v-else>
      {{getVal()}}
    </span>
  </div>
</template>

<script>

import { onBeforeMount, reactive, toRefs, inject, computed } from 'vue';
import { cloneDeep, find, isEmpty, isFunction, isNumber } from 'lodash';
import Validations from '../../utils/Validations';
import QtyInput from '@/components/fields/QtyInput.vue';
import QtyOptions from '../utils/QtyOptions';

export default {
  name: 'Number',
  props: {
    rowField: {
      type: Object,
      default: () => ({}),
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEditing: {
      type: Boolean,
    },
    emitOrderSave: {
      type: Boolean,
      default: false,
    },
    isHeader: {
      type: Boolean,
    },
  },
  components: {
    QtyInput,
  },
  setup(props, { emit }) {
    const shippingEvents = inject('saveShipping');
    const state = reactive({
      QTY_Max: QtyOptions.CF_QTY_MAX,
      cfValue: null,
      customField: {},
      orderCf: {},
      oldCfValue: '',
    });

    onBeforeMount(() => {
      if (isEmpty(props.rowData.customFields) || !find(props.rowData.customFields, { _id: props.rowField.customField._id })) {
        if(!props.rowData.customFields) {
          props.rowData.customFields = [];
        }
        props.rowData.customFields.push(cloneDeep(props.rowField.customField));
      }
      state.customField = props.rowField.customField;
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        state.oldCfValue = state.cfValue;
      }
    });

    const updateCfValue = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        itemField.value = state.cfValue;
      }
    };
    
    const validateFields = async () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        // await Validations.validateCustomFields(itemField);
        state.orderCf = itemField;
        if (props.emitOrderSave && !isEmpty(shippingEvents) && isFunction(shippingEvents.save)) {
          if (isNumber(itemField.value) && state.oldCfValue !== itemField.value) {
            await shippingEvents.save(props.rowData);
          }
        }
      }
    };

    const isEditable = computed(() => {
      if (props.rowField.isEditable) return true;
      if (props.rowField.noEdit) return false;
      return props.isEditing;
    })

    const getVal = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        return state.cfValue;
      }
      state.cfValue = null
      return 'No number set'
    }

    return {
      ...toRefs(state),
      updateCfValue,
      validateFields,
      isEditable,
      getVal
    }
  }
}


</script>